import { render, staticRenderFns } from "./TaskProyect.vue?vue&type=template&id=0012c18e&scoped=true"
import script from "./TaskProyect.vue?vue&type=script&lang=js"
export * from "./TaskProyect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0012c18e",
  null
  
)

export default component.exports